module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-move-165db5fbf8a2baaf4a5a2504e37e8960.jpg";